<div class="innerpage-fullwithbanner dashboardarea clearfix">
  <div class="left">
    <h2 class="bighead">Property Details</h2>
    <ul class="bread-crumbs">
      <li *ngIf="this.authentication.Principal() || this.authentication.Seller() || this.authentication.Principal1031()">
        <a (click)="onHomeBreadCrumbClick();">
          Home
          <span>|</span>
        </a>
      </li>
      <li *ngIf="this.authentication.Admin()||this.authentication.SuperAdmin()"><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
      <li *ngIf="this.authentication.Principal() || this.authentication.Principal1031">
        <a (click)="onBreadCrumbClick();">{{prevPage}}<span>|</span></a>
      </li>
      <li>Property Details</li>
    </ul>
  </div>
</div>


<div class="to-chart-wrapper container container-1200" style="margin-top:80px; ">
  <div class="cf">
    <div class="margin-bottom-0" *ngIf="Isshowgraph==1">
      <div class="d-flex chart-box-header align-item-center">
        <h2 class="mainhead mainhead2 mr-auto margin-bottom-50">
          <span class="text">{{graphText}}</span>
        </h2>
      </div>

      <div class="row padding-left-14">
        <div class="col-lg-3 col-md-3 col-sm-3  col-xs-12 border-l-10 padding-left-32" *ngIf="IsChartLoaded==1">
          <div class="gray-box1 d-flex flex-direction-colum  margin-bottom-15">
            <h5 class="graylabel margin-bottom-15 myPortfolioNormalHeadingv margin-top-0 margin-bottom-26">Cap Rate Highlights</h5>
            <div class="be-market-data d-flex margin-bottom-15" *ngFor="let highlight of individualHighlightData;let j = index ">
              <div class="d-flex flex-direction-colum flex-1 margin-right-5">
                <p class="bluelabel margin-bottom-10"> {{highlight.name!=null?highlight.name:''}}</p>
                <div class="d-flex in-box-t" *ngIf="highlight.StatusId!=null&&highlight.StatusId==1">
                  <span class="in-box">
                    <svg _ngcontent-serverApp-c331="" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path _ngcontent-serverApp-c331="" fill="#6A7175" d="M9 0C4.027 0 0 4.027 0 9s4.027 9 9 9 9-4.027 9-9-4.027-9-9-9Zm0 2.25L15.75 9 9 15.75v-4.5H2.25v-4.5H9v-4.5Z"></path></svg>
                  </span>
                  <p class="margin-left-10 m-data">
                    {{highlight.currentValue!=null&&highlight.currentValue>0?(highlight.currentValue|number : '1.2-2'):'0.00'}} %   <span class="gray-color">
                      <i container="body" class="userpermissiontooltip" triggers="mouseenter:mouseleave" aria-hidden="true" popover="{{highlight.InfoText}}" popoverTitle="{{(highlight.name!=null?highlight.name:'')+' Cap Rate Info'}}" placement="right">
                        <img src="/assets/img/info-icon-blue.svg" class="info-icon-blue-position">
                      </i>
                      {{highlight.difference!=null&&highlight.difference>0?highlight.difference:'0.00'}}  %
                    </span>
                  </p>
                </div>
                <div class="d-flex gray-d-flex-box" *ngIf="highlight.StatusId!=null&&highlight.StatusId==0">
                  <span class="in-box">
                    <svg _ngcontent-serverApp-c331="" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path _ngcontent-serverApp-c331="" fill="#6A7175" d="M9 0C4.027 0 0 4.027 0 9s4.027 9 9 9 9-4.027 9-9-4.027-9-9-9Zm0 2.25L15.75 9 9 15.75v-4.5H2.25v-4.5H9v-4.5Z"></path></svg>
                  </span>
                  <p class="margin-left-10 m-data">
                    {{highlight.currentValue!=null&&highlight.currentValue>0?(highlight.currentValue|number : '1.2-2'):'0.00'}} %   <span class="gray-color">
                      <i container="body" class="userpermissiontooltip" triggers="mouseenter:mouseleave" aria-hidden="true" popover="{{highlight.InfoText}}" popoverTitle="{{(highlight.name!=null?highlight.name:'')+' Cap Rate Info'}}" placement="right">
                        <img src="/assets/img/info-icon-blue.svg" class="info-icon-blue-position">
                      </i>
                      {{highlight.difference!=null&&highlight.difference>0?highlight.difference:'0.00'}} %
                    </span>
                  </p>
                </div>
                <div class="d-flex in-box-d" *ngIf="highlight.StatusId!=null&&highlight.StatusId!=1&&highlight.StatusId!=0">
                  <span class="in-box">
                    <svg _ngcontent-serverApp-c331="" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path _ngcontent-serverApp-c331="" fill="#6A7175" d="M9 0C4.027 0 0 4.027 0 9s4.027 9 9 9 9-4.027 9-9-4.027-9-9-9Zm0 2.25L15.75 9 9 15.75v-4.5H2.25v-4.5H9v-4.5Z"></path></svg>
                  </span>
                  <p class="margin-left-10 m-data">
                    {{highlight.currentValue!=null&&highlight.currentValue>0?(highlight.currentValue|number : '1.2-2'):'0.00'}} %    <span class="gray-color">
                      <i container="body" class="userpermissiontooltip" triggers="mouseenter:mouseleave" aria-hidden="true" popover="{{highlight.InfoText}}" popoverTitle="{{(highlight.name!=null?highlight.name:'')+' Cap Rate Info'}}" placement="right">
                        <img src="/assets/img/info-icon-blue.svg" class="info-icon-blue-position">
                      </i>
                    {{highlight.difference!=null&&highlight.difference>0?(highlight.difference|number : '1.2-2'):'0.00'}} %
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12 padding-left-32">
          <h5 class="graylabel margin-bottom-15" *ngIf="IsChartLoaded==1">Average Cap Rate</h5>
          <div id="BarRemainingTermCapRate"></div>
        </div>
      </div>
    </div>

    <div class="dashboardstyles section-margin be-dashboard-wrap seller-dashboard-wrap margin-top-40" style="padding-top:20px">
      <ul class="tabheadings clearfix margin-bottom-60">
        <li [class.active]="currentTab == tabs.MarketData" (click)="onTabClick(tabs.MarketData)">
          <a href="javascript:void(0);">
            <span class="icon-tc icon"></span>Market Data
          </a>
        </li>
        <li [class.active]="currentTab == tabs.PropertyMarketing" (click)="onTabClick(tabs.PropertyMarketing)">
          <a href="javascript:void(0);">
            <span class="icon-building icon"></span>Property Marketing
          </a>
        </li>
        <li *ngIf="property.TickerSymbol" [class.active]="currentTab == tabs.CreditProfile" (click)="onTabClick(tabs.CreditProfile)">
          <a href="javascript:void(0);">
            <span class="icon-money2 icon"></span>Credit Profile
          </a>
        </li>
        <li [class.active]="currentTab == tabs.PropertyDetails" (click)="onTabClick(tabs.PropertyDetails)">
          <a href="javascript:void(0);">
            <span class="icon-propertydetails icon"></span>Property Details
          </a>
        </li>
        <li [class.active]="currentTab == tabs.AssetManagement" (click)="onTabClick(tabs.AssetManagement)">
          <a href="javascript:void(0);">
            <span class="icon-sale icon"></span>Asset Management
          </a>
        </li>
        <li [class.active]="currentTab == tabs.DueDelligence" (click)="onTabClick(tabs.DueDelligence)">
          <a href="javascript:void(0);">
            <span class="icon-folder icon"></span>Due Diligence
          </a>
        </li>
        <li *ngIf="property.DataEntryPropertyStatusId != 6949" [class.active]="currentTab == tabs.PropertyHistory" (click)="onTabClick(tabs.PropertyHistory)">
          <a href="javascript:void(0);">
            <span class="icon-comps icon"></span>Property History
          </a>
        </li>
        <li [class.active]="currentTab == tabs.Message" *ngIf="actualproperty!=null && property.DataEntryPropertyStatusId != 6949" (click)="onTabClick(tabs.Message);openMessageTab(templateMessageTab,'panlestyle messagepanel',property)">
          <a href="javascript:void(0);">
            <span class="icon-chat icon"></span>Message
          </a>
        </li>
      </ul>

      <div class="min-heightcontainer" *ngIf="currentTab == tabs.MarketData">
        <ng-container>
          <div class="row">
            <div class="floatinghead clearfix">
            </div>
          </div>
          <div class="clearfix"></div>
          <ng-container>
            <app-market-data-tab [propertyGuid]="propertyGuid" [parentPageId]="1" [UserGuid]="UserGuid"></app-market-data-tab>
          </ng-container>
        </ng-container>
        <div class="clearfix"></div>
      </div>

      <div class="min-heightcontainer" *ngIf="currentTab == tabs.PropertyMarketing">
        <ng-container>
          <div class="row">
            <div class="floatinghead clearfix">
            </div>
          </div>
          <div class="clearfix"></div>
          <ng-container>
            <app-portfolio-marketting [propertyId]="property.Id" [isDashboardEnabled]="isDashboardEnabled" [UserGuid]="UserGuid" [property]="actualproperty"></app-portfolio-marketting>
          </ng-container>
        </ng-container>
        <div class="clearfix"></div>
      </div>

      <div class="min-heightcontainer" *ngIf="currentTab == tabs.CreditProfile">
        <ng-container>
          <div class="row">
            <div class="floatinghead clearfix">

            </div>
          </div>
          <div class="clearfix"></div>
          <ng-container>
            <app-credit-profile [tickerSymbol]="property.TickerSymbol" [tenant]="property.PropertyName" [showSummaryTab]="true"></app-credit-profile>
          </ng-container>
        </ng-container>
        <div class="clearfix"></div>
      </div>

      <div class="min-heightcontainer" *ngIf="currentTab == tabs.PropertyDetails">
        <ng-container>
          <div class="row">
            <div class="floatinghead clearfix">
            </div>
          </div>
          <div class="clearfix"></div>
          <ng-container>
            <app-property-data-tab [propertyGuid]="propertyGuid" [parentPageId]="1"></app-property-data-tab>
          </ng-container>
        </ng-container>
        <div class="clearfix"></div>
      </div>

      <div class="min-heightcontainer" *ngIf="currentTab == tabs.AssetManagement">
        <ng-container>
          <div class="row">
            <div class="floatinghead clearfix">

            </div>
          </div>
          <div class="clearfix"></div>
          <ng-container>
            <h2 class="subhead margin-top-20">
              <span class="text">
                Under Construction: Coming soon in 2023. Stay tuned for release announcements. Join the waitlist to be the first to learn about release information
              </span>
            </h2>
          </ng-container>
        </ng-container>
        <div class="clearfix"></div>
      </div>

      <div class="min-heightcontainer" *ngIf="currentTab == tabs.DueDelligence">
        <ng-container>
          <div class="row">
            <div class="floatinghead clearfix">

            </div>
          </div>
          <div class="clearfix"></div>
          <ng-container>
            <app-portfolio-duediligence-list [propertyId]="property.Id" [property]="property" [canEditProperty]="canEditProperty" [docAccessStatus]="docAccessStatus"></app-portfolio-duediligence-list>
          </ng-container>
        </ng-container>
        <div class="clearfix"></div>
      </div>

      <div class="min-heightcontainer" *ngIf="currentTab == tabs.PropertyHistory">
        <ng-container>
          <div class="row">
            <div class="floatinghead clearfix">

            </div>
          </div>
          <div class="clearfix"></div>
          <ng-container>
            <app-property-history [propertyId]="property.Id" [IsDataEntryPrperty]="isDataEntryProperty" [property]="property" [IsPDeleted]="property.IsDeleted" [YearBuilt]="property.YearBuilt"></app-property-history>
          </ng-container>
        </ng-container>
        <div class="clearfix"></div>
      </div>
    </div>

  </div>
</div>
<ng-template #templateMessageTab>
  <app-messages-view [propertyGuid]="property.LivePropertyGuid" [property]="actualproperty" [modalRef]="modalRef"></app-messages-view>
</ng-template>




